<template>
    <div>
        <h3 class="grey-color mb-3 main_text font-weight-bold">Извещения 44-ФЗ</h3>

        <b-overlay :show="isLoading" opacity="0.6" rounded spinner-variant="primary" style="min-height: 100px">
            <b-row class="mb-2 cabinet_filter">
                <filter-new-text v-model="filter.reg_number" label="Рег.номер закупки" md="6" placeholder="Введите рег.номер закупки" />
                <filter-new-multiple-select v-model="filter.status" :options="filterStatuses" label="Статус закупки" label-class="grey-color" label-field="title" lg="6" md="6" placeholder="Выберите статус" />
                <filter-new-multiple-select v-model="filter.deliverable_groups" :options="$globalDictionaries.deliverableGroups" label="Предмет закупки" label-class="grey-color" lg="6" md="6" placeholder="Выберите предметы закупки" />

                <b-col class="mb-1 mt-auto" lg="3" md="3">
                    <b-btn class="text-uppercase w-100" style="height: 32px; line-height: 15px" variant="custom-green" @click.prevent="getPurchases(false)">НАЙТИ</b-btn>
                </b-col>
                <b-col class="mb-1 mt-auto" lg="3" md="3">
                    <b-btn class="text-uppercase w-100" style="height: 32px; line-height: 15px" variant="custom-outline-secondary" @click.prevent="clearFilter">СБРОС</b-btn>
                </b-col>
            </b-row>

            <b-pagination v-if="purchases && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-2 py-0" />

            <component v-for="purchase in purchases" :key="`${purchase.type}_${purchase.id}`" :is="findComponent(purchase)" :purchase="purchase" @refresh="refresh" />

            <empty-request v-if="!purchases.length && !isLoading"></empty-request>

            <b-pagination v-if="purchases && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-2 py-0" @input="getPurchases()" />
        </b-overlay>
    </div>
</template>

<script>
import FilterNewMultipleSelect from '@/components/common/filter-components/filter-new-multiple-select.vue';
import FilterNewText from '@/components/common/filter-components/filter-new-text.vue';
import CabinetFl44NoticeCard from '@/components/cabinet/fl44/cards/cabinet-fl44-notice-card.vue';
import CabinetFl44UnknownVolumeNoticeCard from '@/components/cabinet/fl44/cards/cabinet-fl44-unknown-volume-notice-card.vue';

export default {
    name: 'cabinet-fl44-notices-list',
    metaInfo: {
        title: 'Закупки 44-ФЗ. Извещения'
    },
    components: {
        CabinetFl44NoticeCard,
        FilterNewText,
        FilterNewMultipleSelect
    },
    data() {
        return {
            purchases: [],
            isLoading: false,
            filter: {
                status: [],
                deliverable_groups: [],
                reg_number: ''
            },
            meta: {
                current_page: 1,
                total: 0,
                per_page: 1
            }
        };
    },
    async mounted() {
        await this.getPurchases();
        this.$scrollToTop();
    },
    methods: {
        getFilters(page = true) {
            const filterValues = [];
            for (let obj of Object.entries(this.filter)) {
                if (obj[1]) {
                    filterValues[obj[0]] = obj[1];
                }
            }
            return {
                ...filterValues,
                page: page ? this.meta.current_page : 1
            };
        },
        clearFilter() {
            this.filter.deliverable_groups = [];
            this.filter.status = [];
            this.filter.reg_number = '';
            this.getPurchases(false);
        },

        async getPurchases(page = true, isLoading = true) {
            this.isLoading = isLoading;
            const purchasesData = await this.$api.personal.fl44.getNoticesList(this.getFilters(page));
            this.purchases = purchasesData.data;
            this.meta = purchasesData.meta;
            this.isLoading = false;
        },
        refresh() {
            this.getPurchases();
        },
        findComponent(purchase) {
            switch (purchase.type) {
                case 'fl44':
                    return CabinetFl44NoticeCard;
                default:
                    return CabinetFl44UnknownVolumeNoticeCard;
            }
        }
    },
    computed: {
        filterStatuses() {
            const filterValues = ['draft', 'signed', 'revoked', 'accepting', 'summarizing', 'summarized', 'cancelled', 'failed', 'blocked'];
            return this.$globalDictionaries.purchaseStatuses.filter((status) => filterValues.some((value) => status.id === value));
        }
    }
};
</script>
